<script setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { sugerirSubtopicos } from "@/api/criarQuestoesIA";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";
const store = useCriarQuestoesStore();
const {topicoDigitado, subtopicosSugeridos, menssagemErroInline } = storeToRefs(store);
const btnLoading = ref(false);


async function criarSubtopicos() {
    if(topicoDigitado.value.trim() === ''){
        menssagemErroInline.value = true;
        return;
    }
    btnLoading.value = true;
    let resultado = await sugerirSubtopicos(topicoDigitado.value);
    resultado = JSON.parse(resultado);
    subtopicosSugeridos.value = resultado.conceitos.map(subtopico => {
        return { texto: subtopico, status: false }
    })
    btnLoading.value = false;
}

watch(topicoDigitado, () => {
    if(topicoDigitado.value.trim() !== ''){
        menssagemErroInline.value = false
    }
})

</script>
<template>
    <div class="flex flex-column gap-2">
        <label for="topico">Tópico</label>
        <div class="flex flex-row gap-2 align-items-start">
            <div class="w-full ">
                <InputText id="topico" v-model="topicoDigitado" class="w-full" :invalid="menssagemErroInline"/>
                <label v-if="menssagemErroInline" class="text-red-500">Insira um tópico</label>
            </div>
            <Button v-tooltip.top="'Sugerir Subtópicos'" :loading="btnLoading" icon="pi pi-sparkles"
                @click="criarSubtopicos" severity="secondary" text />
        </div>
    </div>
</template>